@for (column of tableColumns; track column) {
  <td
    class="cell"
    [ngClass]="{ 'description-cell': column === 'description' }"
    >
    <span class="d-flex">
      @if (column === 'partNumber') {
        <span>
          @for (p of counter(row.level); track p) {
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              >
            }
          </span>
        }
        @switch (getColumnType(column)) {
          @case ('normal') {
            <span>
              @if (isPart) {
                <span>
                  <div
          [ngClass]="{
            'width-partNumber': column === 'partNumber'
          }"
                    >
                    @if (column !== 'stockRange') {
                      <span>
                        @if (column === 'purchasePartNumber') {
                          <span
              [ngbTooltip]="
                getTreeCellTooltip(
                  column,
                  app.fieldId.part.purchasePartNumber,
                  row.node.part[column]
                )
              "
                            >
                            {{ row.node.part[column] }}
                          </span>
                        }
                        @if (column !== 'purchasePartNumber') {
                          <span>
                            {{ row.node.part[column] }}
                          </span>
                        }
                      </span>
                    }
                    @if (column === 'stockRange' && row.node.part.stockRange > -1) {
                      <span
                        >
                        {{ row.node.part[column] }}
                      </span>
                    }
                  </div>
                </span>
              }
              @if (isManufacturer) {
                <span>
                  <div [ngClass]="{ 'description-cell': column === 'name' }">
                    @if (column != 'stockRange') {
                      <span>
                        @if (column === 'purchasePartNumber') {
                          <span
              [ngbTooltip]="
                getTreeCellTooltip(
                  column,
                  app.fieldId.manufacturer.purchasePartNumber,
                  row.manufacturer[column]
                )
              "
                            >
                            {{ row.manufacturer[column] }}
                          </span>
                        }
                        @if (column !== 'purchasePartNumber') {
                          <span>
                            {{ row.manufacturer[column] }}
                          </span>
                        }
                      </span>
                    }
                    @if (column === 'stockRange' && row.manufacturer.stockRange > -1) {
                      <span
                        >
                        {{ row.manufacturer[column] }}
                      </span>
                    }
                  </div>
                  @if (column === 'description') {
                    <div>
                      {{ row.manufacturer.name }}
                    </div>
                  }
                </span>
              }
            </span>
          }
          @case ('navigateAction') {
            <span>
              @if (isPart) {
                <span>
                  @if (column === 'partNumber') {
                    <span class="cpn-tree-content">
                      @if (!row.node.part.isOpen && !row.node.part.isLeaf) {
                        <span
                          (click)="app.tree.toggleTreeRow(row)"
                          class="cpn-tree-toggle"
                          >
                          <i class="fas fa-chevron-right icon-gray pointer"></i>
                        </span>
                      }
                      @if (row.node.part.isOpen) {
                        <span
                          (click)="app.tree.toggleTreeRow(row)"
                          class="cpn-tree-toggle"
                          >
                          <i class="fas fa-chevron-down icon-gray pointer"></i>
                        </span>
                      }
                      @if (row.node.part.isLeaf) {
                        <span
                          class="cpn-tree-toggle"
                        ></span>
                      }
                      <a
                        class="partNumber cpn-tree-link"
                        (click)="app.treeRow.navigateToDetailPage(row)"
                        >
                        @if (activeMPNs > 0) {
                          <i
                            class="fas fa-cube cpn-tree-icon cpn-tree-icon-assembly"
                            aria-hidden="true"
                          ></i>
                        }
                        @if (activeMPNs === 0) {
                          <i
                            class="fas fa-cog cpn-tree-icon cpn-tree-icon-part"
                            aria-hidden="true"
                          ></i>
                        }
                        <span class="cpn-tree-copy">
                          <span class="cpn-tree-value">{{ row.node.part[column] }}</span>
                        </span>
                      </a>
                    </span>
                  } @else {
                    @if (!row.node.part.isOpen && !row.node.part.isLeaf) {
                      <span
                        (click)="app.tree.toggleTreeRow(row)"
                        ><i class="far fa-plus icon-gray pointer p-1"></i
                      ></span>
                    }
                    @if (row.node.part.isOpen) {
                      <span (click)="app.tree.toggleTreeRow(row)"
                        ><i class="far fa-minus icon-gray pointer p-1"></i
                      ></span>
                    }
                    <a
                      class="partNumber text-center"
                      (click)="app.treeRow.navigateToDetailPage(row)"
                      >
                      {{ row.node.part[column] }}
                    </a>
                  }
                </span>
              }
              @if (isManufacturer) {
                <span>
                  @if (column === 'partNumber') {
                    <a
                      class="partNumber cpn-tree-link cpn-tree-manufacturer-link"
                      (click)="app.treeRow.navigateToDetailPage(row)"
                      >
                      <i class="fas fa-building cpn-tree-icon cpn-tree-icon-manufacturer" aria-hidden="true"></i>
                      <span class="cpn-tree-copy">
                        <span class="cpn-tree-value">{{ row.manufacturer.manufacturerPartNumber }}</span>
                      </span>
                    </a>
                  } @else {
                    <a class="partNumber" (click)="app.treeRow.navigateToDetailPage(row)">
                      <i class="fa fa-angle-right icon-gray"></i>
                      {{ row.manufacturer[column] }}
                    </a>
                  }
                </span>
              }
            </span>
          }
          @case ('quantity') {
            <span>
              @if (isPart) {
                <span>{{ row.quantity ? row.quantity : 1 }}</span>
              }
              @if (isManufacturer) {
                <span></span>
              }
            </span>
          }
          @case ('optionText') {
            <span>
              <!-- For type optionText the values that are displayed, are calculated in the getStatusTextAndColor method -->
              @if (isPart) {
                @if (isLeonardoImpactCategory(column)) {
                  <span
                    tooltipClass="tree-category-tooltip"
                    [ngbTooltip]="
                      getTreeCellTooltip(
                        column,
                        app.fieldId.part.productCategory,
                        row.node.part[column]
                      )
                    "
                  >
                    {{ row.node.part[column] }}
                  </span>
                } @else {
                  <span>
                    {{ row.node.part[column] }}
                  </span>
                }
              }
              @if (isManufacturer) {
                <span>
                  {{ row.manufacturer[column] }}
                </span>
              }
            </span>
          }
          @case ('where-used') {
            <span>
              @if (isPart && row.level !== 0) {
                <span
                  >
                  <i
                    class="fas fa-sitemap fa-rotate-270 pointer icon-blue p-1"
                    (click)="openWhereUsedTreeModal(row.node.part.partNumber)"
                    [title]="app.text.part.whereUsed"
                  ></i>
                </span>
              }
            </span>
          }
          @case ('radio') {
            <span>
              @if (isPart) {
                <span>
                  @if (app.field.isTrue(row.node.part[column])) {
                    <i
                      class="far fa-dot-circle"
                    ></i>
                  }
                  @if (app.field.isFalse(row.node.part[column])) {
                    <i class="fal fa-circle"></i>
                  }
                </span>
              }
              @if (isManufacturer) {
                <span>
                  @if (app.field.isTrue(row.manufacturer[column])) {
                    <i
                      class="fas fa-star-of-life"
                    ></i>
                  }
                </span>
              }
            </span>
          }
          @case ('actions') {
            <span>
              @if (app.permission.RM.createCase) {
                <span>
                  @if (
                    !getCase &&
                    isManufacturer &&
                    row.manufacturer.manufacturerPartNumber !== ''
                    ) {
                    <i
                      class="far fa-folder-plus icon-blue pointer p-1"
                      (click)="app.treeRow.newCase(row); app.treeRow.currentRow = row"
                    ></i>
                  }
                  @if (getCase) {
                    <i
                      class="fas fa-folder-open icon-blue pointer p-1"
          (click)="
            seeOpenedCasesModal.open();
            app.treeRow.getCasesByPartNumber(row);
            app.treeRow.currentRow = row
          "
                    ></i>
                  }
                </span>
              }
            </span>
          }
          @case ('matchedSystem') {
            <span>
              @if (isManufacturer) {
                <a
                  (click)="app.treeRow.navigateToMatchingPage(row)"
                  >
                  @if (manufacturerStatus === 'matched') {
                    <i
                      class="far fa-link icon-blue pointer p-1"
                    ></i>
                  }
                  @if (manufacturerStatus === 'manual') {
                    <i
                      class="fa fa-user-circle icon-blue pointer p-1"
                    ></i>
                  }
                  @if (manufacturerStatus === 'unmatched') {
                    <i
                      class="far fa-unlink icon-blue pointer p-1"
                    ></i>
                  }
                  @if (manufacturerStatus === 'override') {
                    <i
                      class="far fa-hand-paper icon-blue"
                    ></i>
                  }
                  @if (manufacturerStatus === 'manualAssignment') {
                    <i
                      class="fas fa-user-edit icon-blue pointer"
                    ></i>
                  }
                </a>
              }
            </span>
          }
          @case ('badge') {
            <span>
              @if (isPart && row.node.part[column] && row.node.part[column] !== 'withoutData') {
                <span
                  class="badge compact-tree-badge"
        [ngClass]="{
          'status-column-badge':
            column === 'obsolescenceStatus' ||
            column === 'obsolescenceStatus2years' ||
            column === 'obsolescenceStatus4years' ||
            column === 'obsolescenceStatus6years' ||
            column === 'obsolescenceStatus8years'
        }"
                  [ngStyle]="row.node.part[column].color"
                  >
                  {{ row.node.part[column].label }}
                </span>
              }
              @if (isManufacturer && row.manufacturer[column] && row.manufacturer[column] !== 'withoutData') {
                <span
                  class="badge compact-tree-badge"
        [ngClass]="{
          'status-column-badge':
            column === 'obsolescenceStatus' ||
            column === 'obsolescenceStatus2years' ||
            column === 'obsolescenceStatus4years' ||
            column === 'obsolescenceStatus6years' ||
            column === 'obsolescenceStatus8years'
        }"
                  [ngStyle]="row.manufacturer[column].color"
                  >
                  {{ row.manufacturer[column].label }}
                </span>
              }
            </span>
          }
          @case ('link') {
            <span>
              @if (isPart) {
                <span></span>
              }
              @if (isManufacturer) {
                <span>
                  @if (row.manufacturer[column]) {
                    <a
                      [href]="row.manufacturer[column]"
                      target="_blank"
                      >
                      <i class="fas fa-file icon-blue"></i>
                    </a>
                  }
                </span>
              }
            </span>
          }
          @case ('statusAlerts') {
            <span>
              @if (statusAlertInfo.showIcon) {
                <span
                  class="hoverIconArea"
                  [ngbTooltip]="statusAlertInfo.tooltipText"
                  >
                  <i class="fa-regular fa-message-exclamation p-1"></i>
                </span>
              }
            </span>
          }
          @case ('pending') {
            <span>
              @if (isPart) {
                <span></span>
              }
              @if (isManufacturer) {
                <span>
                  @if (row.manufacturer[column]) {
                    <span>
                      {{ app.text.manufacturer.pending }}
                    </span>
                  }
                </span>
              }
            </span>
          }
          @case ('activeMPNs') {
            <span>
              @if (isPart) {
                <span>
                  @if (activeMPNs === 0) {
                    <span>
                      {{ row.node.part["activeMPNs"] }}
                    </span>
                  }
                  @if (activeMPNs > 0) {
                    <span>
                      {{ app.text.part.notApplicableAssembly }}
                    </span>
                  }
                </span>
              }
              @if (isManufacturer) {
                <span></span>
              }
            </span>
          }
          @case ('textCenter') {
            <span>
              @if (isPart) {
                <span>{{ row.node.part[column] }}</span>
              }
              @if (isManufacturer) {
                <span>
                  @if (row.manufacturer[column]) {
                    <span>
                      {{ row.manufacturer[column] }}
                    </span>
                  }
                </span>
              }
            </span>
          }
          @case ('decimalNumber') {
            <span>
              @if (isPart) {
                <span>
                  <div>
                    @if (row.node.part.stockRange > -1) {
                      <span>
                        {{ row.node.part[column] }}
                      </span>
                    }
                  </div>
                </span>
              }
              @if (isManufacturer) {
                <span>
                  @if (row.manufacturer.stockRange > -1) {
                    <span>
                      {{ row.manufacturer[column] }}
                    </span>
                  }
                </span>
              }
            </span>
          }
          @case ('limit') {
            <span>
              <!-- limit the size of the displayed content -->
              @if (isPart) {
                <span>
                  <app-limit [textInput]="row.node.part[column]" limit="20"> </app-limit>
                </span>
              }
            </span>
          }
          @case ('date') {
            <span>
              @if (isPart && row.node.part[column] > 0) {
                <span>
                  {{ row.node.part[column] | date : "yyyy-MM-dd" : "UTC" }}
                </span>
              }
              @if (isManufacturer && row.manufacturer[column] > 0) {
                <span>
                  {{ row.manufacturer[column] | date : "yyyy-MM-dd" : "UTC" }}
                </span>
              }
            </span>
          }
        }
      </span>
    </td>
  }

  <app-modal
    #seeWhereUsedTreeModal
    [modalTitle]="app.text.part.whereUsed"
    [modalType]="'showWhereUsedTree'"
    [showButtons]="false"
    [whereUsedCustomer]="app.customers.expectCurrent"
    [whereUsedPartNumber]="selectedWhereUsedPartNumber"
    >
  </app-modal>

  <app-modal
    #seeOpenedCasesModal
    [modalTitle]="app.text.thread.threads"
    [modalType]="'showListOfCases'"
    [showButtons]="false"
    >
  </app-modal>
